<!-- There was a problem on our end -->
<template>
  <div class="content max-700 m-auto invoice-details">
    <i18n-t keypath="CreateAolAccount.aolTokenErrors.problemOnOurEndP1" tag="p" scope="global">
      <template #mySubscriptions>
        <button class="inline-btn-link" @click="openAolSubscription">{{ tn("mySubscriptions") }}</button>
      </template>
    </i18n-t>
    <i18n-t keypath="CreateAolAccount.aolTokenErrors.problemOnOurEndP2" tag="p" scope="global">
      <template #contactAol>
        <button class="inline-btn-link" @click="openAolSupport">{{ tn("contactAol") }}</button>
      </template>
    </i18n-t>
  </div>
</template>

<script setup lang="ts">
import { t } from "@/i18n";
import { openAolSupportPage, openAolSubscriptionsPage } from "../AolCreateAccountHelper";

const baseComponentName = "CreateAolAccount";

function tn(v: string, params?: Record<string, unknown>): string {
  return t(`${baseComponentName}.${v}`, params);
}

function openAolSupport() {
  openAolSupportPage();
}

function openAolSubscription() {
  openAolSubscriptionsPage(false);
}
</script>
